var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var callRequest = require('../../../../../include/_js/callback/callback-request');

        var _require = require('../../../../../include/_js/callback/working-time'),
            isWorkingTimeNow = _require.isWorkingTimeNow;

        var win = window;

        var CallbackForm = function () {
            function CallbackForm() {
                _classCallCheck(this, CallbackForm);
            }

            _createClass(CallbackForm, null, [{
                key: "init",
                value: function init() {
                    CallbackForm.bindGeneralEventListeners();
                    CallbackForm.bindSpecificEventListeners();
                }

                /**
                 * Обработчики конкретных форм
                 */

            }, {
                key: "bindSpecificEventListeners",
                value: function bindSpecificEventListeners() {
                    // emerge-callback-form
                    $('#show-emerge-callback').one('click', function (e) {
                        e.preventDefault();
                        e.stopPropagation(); // disable '.callback-form-submit' event listener callback
                        $('.emerge-callback-form').addClass('active');
                        $(this).html('Отправить').addClass('callback-form-submit analytic-event').data('event', 'callbackFloating.create');
                    });
                    // toggle emerge-callback-form
                    var isVisible = false;
                    $(window).on('scroll', window.utils.throttle(function () {
                        if ($(this).scrollTop() > 300) {
                            if (!isVisible) {
                                isVisible = true;
                                $('#emerge-callback-form').addClass('show-callback');
                            }
                        } else if (isVisible) {
                            isVisible = false;
                            $('#emerge-callback-form').removeClass('show-callback');
                        }
                    }, 150));

                    // nauryz form
                    $('.show-nauryz-callback-form').on('click', function () {
                        CallbackForm.showCallbackPopupFormNauryz();
                    });
                }

                /**
                 * Обработчики, общие для всех форм
                 */

            }, {
                key: "bindGeneralEventListeners",
                value: function bindGeneralEventListeners() {
                    $('body').on('click', '.callback-form-submit', function (e) {
                        e.preventDefault();
                        var $button = $(this);
                        var $form = $button.closest('.callback-form');
                        if (!$form.length) {
                            return;
                        }
                        var formType = $button.data('formType') || '';
                        var $resultField = $form.find('.callback-result-wrap');

                        var submitCallback = function submitCallback(params) {
                            var $phoneContainer = $form.find('.callback-widget-phone').closest('.form-group');

                            if (!params.isChooseCallTime && !isWorkingTimeNow()) {
                                // Уходим на другую форму для запроса доп. данных.
                                // убираем подсветку валидации данных с формы, c которой уходит focus
                                $phoneContainer.removeClass('has-error');
                                // Открывает форму с возможностью выбрать время звонка
                                CallbackForm.showCallbackPopupForm(params);
                                return;
                            }

                            if (!params.validate()) {
                                if (params.haveError(params.errorFields.PHONE)) {
                                    $phoneContainer.addClass('has-error');
                                }
                                return;
                            }
                            $phoneContainer.removeClass('has-error');
                            CallbackForm.toggleSubmitButton($button, false);
                            $resultField.html(win.getMessageTemplate('loading')).removeClass('hidden');

                            // TODO loading
                            // показываем контейнер результата заранее
                            // т.к. сообщение loading показывается там же, где и результат,
                            $form.addClass('state-result');

                            callRequest.create(params, function (response) {
                                CallbackForm.toggleSubmitButton($button, true);
                                CallbackForm.showResultMessage({
                                    $form: $form,
                                    $resultField: $resultField,
                                    response: response,
                                    isDelayed: params.isChooseCallTime,
                                    formType: formType
                                });
                            });
                        };

                        var params = CallbackForm.buildFormParams($form);
                        if (window.app.useGoogleCaptchaForCallback) {
                            window.loadGoogleCaptcha().then(function () {
                                return grecaptcha.execute(window.app.googleCaptchaSiteKey, {
                                    action: 'callback_request'
                                });
                            }).then(function (token) {
                                params.recaptchaToken = token;
                                submitCallback(params);
                            }).catch(function (error) {
                                console.error('Error with reCAPTCHA:', error);
                                CallbackForm.toggleSubmitButton($button, true);
                            });
                        } else {
                            submitCallback(params);
                        }
                    }).on('click', '.callback-choose-time button', function () {
                        var $button = $(this);
                        var time = $button.data('time');
                        $button.parent().find('.active').removeClass('active');
                        $button.addClass('active');
                        $('.callback-widget-delayed-time').val(time);
                    }).on('click', '.open-callback-popup', function () {
                        CallbackForm.showCallbackPopupForm();
                    }).on('click', '.close', function () {
                        var $alert = $(this).closest('.alert');
                        if ($alert.hasClass('alert-success')) {
                            CallbackForm.clearForm();
                        }
                        $alert.remove();
                    });
                }

                /**
                 * @param $form
                 * @return {CallbackParams}
                 */

            }, {
                key: "buildFormParams",
                value: function buildFormParams($form) {
                    var $cityField = $form.find('.callback-widget-city_id');
                    var $formTypeField = $form.find('.callback-widget-form_type_id');
                    var $phoneField = $form.find('.callback-widget-phone');

                    var params = {
                        cityId: $cityField.val(),
                        formTypeId: $formTypeField.val(),
                        phone: $phoneField.val().trim(),
                        isChooseCallTime: 0
                    };

                    var $clientNameField = $form.find('.callback-widget-name');
                    if ($clientNameField.length) {
                        params.clientName = $clientNameField.val();
                    }

                    var isChooseCallTime = parseInt($form.find('.callback-widget-is-choose-time').val(), 10);
                    if (isChooseCallTime) {
                        params.isChooseCallTime = 1;
                        var $date = $form.find('.callback-widget-delayed-date');
                        var $time = $form.find('.callback-widget-delayed-time');
                        params.callDate = $date.length ? $date.val() : '';
                        params.callTime = $time.length ? $time.val() : '';
                    }

                    return new callRequest.Params(params);
                }
            }, {
                key: "toggleSubmitButton",
                value: function toggleSubmitButton($button, enabled) {
                    $button.prop('disabled', !enabled).toggleClass('disabled', !enabled);
                }
            }, {
                key: "getResponseMessageHtml",
                value: function getResponseMessageHtml(title, hint) {
                    var imageHtml = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

                    title = title.toUpperCase();
                    return imageHtml + "\n            <div class=\"block-title\">" + title + "</div>\n            <div class=\"block-hint\">" + hint + "</div>";
                }
            }, {
                key: "getResultMessageImageHtml",
                value: function getResultMessageImageHtml(isDelayed, formType) {
                    var imagePath = '';
                    if (isDelayed) {
                        imagePath = '/img/night-time.png';
                    } else {
                        imagePath = '/img/france-woman.png';
                    }
                    if (formType === 'short') {
                        imagePath = '';
                    }

                    return imagePath === '' ? '' : "<img src=\"" + imagePath + "\">";
                }

                /**
                 * @param $form
                 * @param $resultField
                 * @param {CallbackCreateResponse} response
                 * @param isDelayed
                 * @param formType
                 */

            }, {
                key: "showResultMessage",
                value: function showResultMessage(_ref) {
                    var $form = _ref.$form,
                        $resultField = _ref.$resultField,
                        response = _ref.response,
                        isDelayed = _ref.isDelayed,
                        formType = _ref.formType;

                    var title = response.title.toUpperCase() + '!';
                    var message = '';
                    if (response.success) {
                        if ($form.closest('#bspopup').length === 1) {
                            $('.callback-on-working, .callback-night-time, .callback-inputs', $form).addClass('hidden');
                            message = CallbackForm.getResponseMessageHtml(title, response.message, CallbackForm.getResultMessageImageHtml(isDelayed, formType));
                        } else {
                            message = win.getMessageTemplate('success', CallbackForm.getResponseMessageHtml(title, response.message));
                        }
                    } else {
                        message = win.getMessageTemplate('error', CallbackForm.getResponseMessageHtml(title, response.message));
                    }

                    // Показываем экран с сообщением
                    $resultField.html(message);
                    $form.addClass('state-result');
                }

                /**
                 * Показать форму колбека в модальном окне, форма для выбора времени звонка
                 * @param {CallbackParams|null} params
                 */

            }, {
                key: "showCallbackPopupForm",
                value: function showCallbackPopupForm() {
                    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    var html = $('#callback-form-popup').html();
                    CallbackForm.renderCallbackForm(html, params);
                }

                /**
                 * Форма для акции "Туры на Наурыз"
                 * @param {CallbackParams|null} params
                 */

            }, {
                key: "showCallbackPopupFormNauryz",
                value: function showCallbackPopupFormNauryz() {
                    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    var html = $('#callback-nauryz').html();
                    CallbackForm.renderCallbackForm(html, params, 720);
                }

                /**
                 * @param {string} html
                 * @param {CallbackParams|null} params
                 * @param {number} width
                 */

            }, {
                key: "renderCallbackForm",
                value: function renderCallbackForm(html) {
                    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 530;

                    var isWorkTime = isWorkingTimeNow();
                    win.bs3popup({
                        content: html,
                        width: width,
                        setLock: true
                    });

                    var $popup = $('#bspopup');
                    var $form = $('.callback-form', $popup);
                    if (isWorkTime) {
                        $form.find('.callback-on-working').removeClass('hidden');
                        $form.find('.callback-night-time').addClass('hidden');
                        $form.find('.callback-widget-is-choose-time').val(0);
                    } else {
                        $form.find('.callback-night-time').removeClass('hidden');
                        $form.find('.callback-on-working').addClass('hidden');
                        $form.find('.callback-widget-is-choose-time').val(1);
                    }

                    $form.removeClass('state-result');
                    $('.phone-mask', $popup).mask('+7(999)999-99-99');
                    if (params) {
                        $('.callback-widget-phone').val(params.phone);
                        var $formTypeField = $form.find('.callback-widget-form_type_id');
                        $formTypeField.val(params.formTypeId || $formTypeField.data('default'));
                    }

                    CallbackForm.clearForm();
                    win.bs3popup('show');
                }
            }, {
                key: "clearForm",
                value: function clearForm() {
                    var $form = $('.emerge-callback-form');

                    $form.find('.callback-widget-name').val('');
                    $form.find('.callback-widget-phone').val('');
                }
            }]);

            return CallbackForm;
        }();

        CallbackForm.init();
    }, { "../../../../../include/_js/callback/callback-request": 5, "../../../../../include/_js/callback/working-time": 6 }], 2: [function (require, module, exports) {
        var FIELD_PHONE = 'phone';
        var FIELD_DATE_TIME = 'dateTime';

        var win = window;

        var PHONE_LENGTH = 10;
        function clearPhone(phone) {
            return ('' + phone).trim()
            // remove phone mask code
            .replace('+7', '').replace(/\D/g, '');
        }

        var CallbackParams = function () {
            function CallbackParams(params) {
                _classCallCheck(this, CallbackParams);

                this.srcId = win.app.src_id ? win.app.src_id : null;
                this.vUid = win.app.v_uid ? win.app.v_uid : '';

                this.clientName = params.hasOwnProperty('clientName') ? params.clientName : '';
                this.cityId = parseInt(params.cityId, 10);
                this.formTypeId = parseInt(params.formTypeId, 10);
                this.phone = params.phone; // Важно сохранить форматирование, для проброса в maskedInput
                this.isChooseCallTime = params.hasOwnProperty('isChooseCallTime') ? parseInt(params.isChooseCallTime, 10) : 0;

                this.callDate = '';
                this.callTime = '';
                this.recaptchaToken = params.recaptchaToken;
                if (this.isChooseCallTime) {
                    this.callDate = params.callDate;
                    this.callTime = params.callTime;
                }

                // Только при изменении времени звонка
                this.requestId = 'requestId' in params ? Number(params.requestId) : null;

                /**
                 * Отдельная "цель" на успешный заказ колебка в YM
                 * @type {string}
                 */
                this.ymConversionEvent = '';
                if (params.ymConversionEvent) {
                    this.setYMConversionEvent(params.ymConversionEvent);
                }
                /**
                 * Отдельная цель на успешный заказ колбека в GA
                 * @type {{eventCategory: string, eventAction: string}|null}
                 */
                this.gaConversionEvent = null;
                if (params.hasOwnProperty('gaConversionEventCategory') && params.hasOwnProperty('gaConversionEventAction')) {
                    this.setGAConversionEvent(params.gaConversionEventCategory, params.gaConversionEventAction);
                }

                this.errorList = {};
                this.errorList[FIELD_PHONE] = {
                    error: false,
                    message: ''
                };
                this.errorList[FIELD_DATE_TIME] = {
                    error: false,
                    message: ''
                };
            }

            _createClass(CallbackParams, [{
                key: "setYMConversionEvent",
                value: function setYMConversionEvent(eventKey) {
                    this.ymConversionEvent = eventKey;
                }
            }, {
                key: "setGAConversionEvent",
                value: function setGAConversionEvent(eventCategory, eventAction) {
                    if (!eventCategory || !eventCategory) {
                        return;
                    }
                    this.gaConversionEvent = {
                        category: eventCategory,
                        action: eventAction
                    };
                }
            }, {
                key: "validate",
                value: function validate() {
                    var isValid = true;
                    if (this.isChooseCallTime) {
                        if (this.callDate === '' || this.callTime === '') {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        } else if (parseInt(this.callTime, 10) === -1) {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        }
                    }

                    if (clearPhone(this.phone).length !== PHONE_LENGTH) {
                        isValid = false;
                        this._addError(FIELD_PHONE, 'Проверьте номер телефона');
                    }

                    return isValid;
                }

                /**
                 *
                 * @param formFields - e.g. $form.serializeArray()
                 * @return {CallbackParams}
                 */

            }, {
                key: "haveError",


                /**
                 * @param {string} field
                 * @return {boolean}
                 */
                value: function haveError(field) {
                    return this.errorList[field].error;
                }
            }, {
                key: "_addError",
                value: function _addError(field, message) {
                    if (!this.errorList.hasOwnProperty(field)) {
                        return false;
                    }

                    this.errorList[field].error = true;
                    this.errorList[field].message = message;
                }
            }, {
                key: "errorFields",
                get: function get() {
                    return {
                        PHONE: FIELD_PHONE,
                        DATETIME: FIELD_DATE_TIME
                    };
                }

                /**
                 * Первое сообщение об ошибке
                 * @return {{field: string, message: string}}
                 */

            }, {
                key: "error",
                get: function get() {
                    var data = { field: '', message: '' };
                    if (this.errorList.phone.error) {
                        data.field = FIELD_PHONE;
                        data.message = this.errorList.phone.message;
                    } else if (this.errorList.dateTime.error) {
                        data.field = FIELD_DATE_TIME;
                        data.message = this.errorList.dateTime.message;
                    }

                    return data;
                }
            }], [{
                key: "loadForm",
                value: function loadForm(formFields) {
                    var params = {};
                    for (var i in formFields) {
                        var field = formFields[i];
                        params[field.name] = field.value;
                    }

                    return new CallbackParams(params);
                }
            }]);

            return CallbackParams;
        }();

        module.exports = CallbackParams;
    }, {}], 3: [function (require, module, exports) {

        /**
         * @param {CallbackParams} params
         * @param {Function} callback
         */
        module.exports = function (params, callback) {
            var requestParams = {
                phone: params.phone,
                cityId: params.cityId,
                requestId: params.requestId,
                callDate: params.callDate,
                callTime: params.callTime
            };

            var response = {
                success: false,
                title: 'Ошибка',
                message: ''
            };

            $.post(window.app.urls.changeCallbackCallTime, requestParams, function (responseData) {
                response.success = responseData.success;
                response.callDateTimeDescription = responseData.callDateTimeDescription;
                if (response.success) {
                    response.title = 'Спасибо';
                    response.message = 'Мы перезвоним ' + responseData.callDateTimeDescription;
                } else {
                    response.title = 'Ошибка';
                    response.message = 'Не удалось изменить время звонка. Извините за неудобства';
                }

                callback(response);
            }, 'json');
        };
    }, {}], 4: [function (require, module, exports) {
        var ERROR_NOT_WORKING_TIME = 'not_working_time';
        var ERROR_NON_CORRECT_DATA = 'non_correct_data';
        var ERROR_EXIST = 'callback exist timeout';

        var CallbackRequestEntity = function CallbackRequestEntity(props) {
            _classCallCheck(this, CallbackRequestEntity);

            /** @type number */
            this.id = props.id;
            /** @type string */
            this.callDate = props.callDate;
            /** @type string */
            this.callTime = props.callTime;
            /** @type string */
            this.callDateTimeDescription = props.callDateTimeDescription;
            /** @type {boolean} */
            this.allowChangeCallTime = props.allowChangeCallTime;
        };

        var CallbackCreateResponse = function CallbackCreateResponse() {
            _classCallCheck(this, CallbackCreateResponse);

            this.success = false;
            this.title = '';
            this.message = '';
            /** @type {CallbackRequestEntity|null} */
            this.request = null;
            /** @type {{}|null} */
            this.callTimes = null;
            /** @type {string} */
            this.selectedCallTime = '';
        };

        /**
         * @param {CallbackParams} params
         * @param {Function} callback
         */


        module.exports = function (params, callback) {
            var response = new CallbackCreateResponse();

            if (!params.validate()) {
                callback(response);
                return;
            }

            var requestParams = {
                srcId: params.srcId,
                vUid: params.vUid,

                cityId: params.cityId,
                formTypeId: params.formTypeId,
                phone: params.phone,
                isChooseCallTime: params.isChooseCallTime
            };
            if (requestParams.isChooseCallTime) {
                requestParams.callDate = params.callDate;
                requestParams.callTime = params.callTime;
            }
            if (params.clientName) {
                requestParams.clientName = params.clientName;
            }

            requestParams.recaptchaToken = params.recaptchaToken;

            $.post(window.app.urls.addCallback, requestParams, function (responseData) {
                if (!responseData.success) {
                    response.title = 'Ошибка';
                    // data.allowRepeat = false;
                    switch (responseData.errorType) {
                        case ERROR_NOT_WORKING_TIME:
                            response.message = 'К сожалению, рабочий день окончен';
                            break;
                        case ERROR_NON_CORRECT_DATA:
                            response.message = 'Введены некорректные данные';
                            break;
                        // case ERROR_EXIST:
                        //     title = 'Мы скоро вам перезвоним';
                        //     // data.allowRepeat = false;
                        //     break;
                        default:
                            response.message = 'Извините, произошла ошибка. Попробуйте позднее';
                            break;
                    }
                } else {
                    response.success = true;
                    response.title = 'Спасибо';
                    response.request = new CallbackRequestEntity(responseData.request);
                    response.callTimes = responseData.callTimes;
                    response.selectedCallTime = responseData.selectedCallTime;
                    if (requestParams.isChooseCallTime) {
                        response.message = 'Наш менеджер свяжется с вами в указанное время';
                    } else {
                        response.message = 'Наш менеджер свяжется с вами в ближайшее время';
                    }

                    // отмечаем что был заказан коллбек
                    window.tracking.setEvent('callback.create');
                    $('body').trigger('callback:success'); // проброс в angular
                    if (params.ymConversionEvent) {
                        window.tracking.setYaEvent(params.ymConversionEvent);
                    }
                    if (params.gaConversionEvent) {
                        var gaEvent = params.gaConversionEvent;
                        window.tracking.setGAEvent(gaEvent.category, gaEvent.action);
                    }
                }

                callback(response);
            }, 'json');
        };
    }, {}], 5: [function (require, module, exports) {
        var CallbackParams = require('./CallbackParams');
        var callRequestCreate = require('./callback-request-create-fn');
        var changeCallTime = require('./callback-request-change-call-time-fn');

        module.exports = {
            Params: CallbackParams,
            create: callRequestCreate,
            changeCallTime: changeCallTime
        };
    }, { "./CallbackParams": 2, "./callback-request-change-call-time-fn": 3, "./callback-request-create-fn": 4 }], 6: [function (require, module, exports) {
        var DEFAULT_WORK_START_HOUR = 10;
        var DEFAULT_WORK_END_HOUR = 19;
        var SATURDAY_WORK_END_HOUR = 15;

        /**
         * @param date
         * @return {{from: number, to: number}|null}
         * @private
         */
        function getWorkingTimeBounds(date) {
            var dayOfWeek = date.getDay();
            if (dayOfWeek === 0) {
                // в вс не работаем
                return null;
            }

            var bounds = {
                from: DEFAULT_WORK_START_HOUR,
                to: DEFAULT_WORK_END_HOUR
            };

            if (dayOfWeek === 6) {
                // в сб до 3 можно подать заявку
                bounds.to = SATURDAY_WORK_END_HOUR;
            }

            return bounds;
        }

        module.exports = {
            isWorkingTimeNow: function isWorkingTimeNow() {
                if (window.app.debug) {
                    return false;
                }
                var now = new Date();
                var currentHour = now.getHours();

                // var sundayDate = '2018-4-8';
                // var d = new Date(sundayDate);
                // d.setHours(8);

                var timeBounds = getWorkingTimeBounds(now);
                if (timeBounds === null) {
                    return false;
                }

                var isNotWorkingMorning = currentHour < timeBounds.from;
                var isNotWorkingEvening = currentHour >= timeBounds.to;

                return !(isNotWorkingMorning || isNotWorkingEvening);
            }
        };
    }, {}] }, {}, [1]);